<template>
  <div class="actions flex justify-between">
    <div class="actions-links">
      <a v-for="(item, index) in items" :key="index"
        href="#"
        class="link dim underline"
        :class="[item.enabled ? 'blue' : 'text-tertiary action-disabled']"
        @click.prevent="$emit('action', item)"
      >
        {{ item.title }}
      </a>
    </div>
    <slot name="corner"/>
  </div>
</template>

<script>
import Checkbox from '@/components/ui/Checkbox.vue'

export default {
  components: {
    Checkbox
  },
  props: {
    items: { type: Array }
  }
}
</script>

<style lang="scss" scoped>
.actions {
  border-bottom: .25rem solid #eef2f6;
  padding-bottom: .75rem;
}
.actions-links {
  a {
    &:not(:first-child) {
      margin-left: 1rem;
    }
  }
}
.action-disabled {
  pointer-events: none;
  cursor: default;
}
</style>
